import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ProductImageGallery = ({ images: productImages }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  // Use provided images or fallback to sample images
  const fallbackImages = [
    require("../../../../../assets/product.png"),
    require("../../../../../assets/addimage1.png"),
    require("../../../../../assets/addimage1.png"),
    require("../../../../../assets/addimage1.png"),
  ];

  // If product images are provided, use them
  // Otherwise, use the fallback images
  const images =
    productImages && productImages.length > 0 ? productImages : fallbackImages;

  const handlePrevImage = () => {
    setSelectedImage(prev => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setSelectedImage(prev => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="space-y-4">
      {/* Main Image */}
      <div className="relative aspect-square rounded-md overflow-hidden border border-gray-200">
        <img
          src={images[selectedImage]}
          alt="Product"
          className="w-full h-full object-contain bg-white"
        />
        <div className="absolute inset-0 flex items-center justify-between">
          <button
            onClick={handlePrevImage}
            className="ml-2 w-8 h-8 flex items-center justify-center rounded-full bg-white/70 hover:bg-white border border-gray-200">
            <ChevronLeft size={18} className="text-gray-700" />
          </button>
          <button
            onClick={handleNextImage}
            className="mr-2 w-8 h-8 flex items-center justify-center rounded-full bg-white/70 hover:bg-white border border-gray-200">
            <ChevronRight size={18} className="text-gray-700" />
          </button>
        </div>
      </div>

      {/* Thumbnail Gallery */}
      <div className="grid grid-cols-4 gap-2">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(index)}
            className={`relative aspect-square overflow-hidden rounded-md ${
              selectedImage === index
                ? "ring-2 ring-[#5652B0]"
                : "border border-gray-200"
            }`}>
            <img
              src={image}
              alt={`Product thumbnail ${index + 1}`}
              className="w-full h-full object-cover"
            />
            {selectedImage === index && (
              <div className="absolute inset-0 border-2 border-[#5652B0] rounded-md"></div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductImageGallery;
